import { Injectable } from '@angular/core';
import { ComponentService } from '../../services/component.service';
import { ToastComponent } from '../components/toast/toast.component';

@Injectable()
export class ToastService {
  constructor(private componentService: ComponentService) {}

  open(title: string) {
    const ref = this.componentService.appendComponentToBody(ToastComponent);
    ref.instance.title = title;
    ref.instance.componentRef = ref;
  }
}
